
    <span class="tools-container" [innerHTML]="tools$ | async"></span>
  